import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth.jsx';
import { RouteGuard } from './components/RouteGuard.jsx';
import { Login } from './pages/Login.jsx';
import { Home } from './pages/Home.jsx';
import { Employees } from './pages/Employees.jsx';
import { EmployeeProfile } from './pages/EmployeeProfile.jsx';
import { WarningDetail } from './pages/WarningDetail.jsx';
import { WarningLetter } from './pages/WarningLetter.jsx';
import { AttendanceMonth } from './pages/AttendanceMonth.jsx';
import { IssueWarning } from './pages/IssueWarning.jsx';
import { LeaveApprovals } from './pages/LeaveApprovals.jsx';
import { LeaveRequest } from './pages/LeaveRequest.jsx';
import { EvaluationCycle } from './pages/EvaluationCycle.jsx';
import { EvaluationForm } from './pages/EvaluationForm.jsx';
import { Recommendations } from './pages/Recommendations.jsx';
import { Severance } from './pages/Severance.jsx';
import { Recognize } from './pages/Recognize.jsx';
import { Me } from './pages/Me.jsx';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* manager + admin */}
          <Route path="/" element={
            <RouteGuard allow={['admin', 'manager']}><Home /></RouteGuard>
          } />
          <Route path="/employees" element={
            <RouteGuard allow={['admin', 'manager']}><Employees /></RouteGuard>
          } />
          <Route path="/employees/:id" element={
            <RouteGuard allow={['admin', 'manager']}><EmployeeProfile /></RouteGuard>
          } />
          <Route path="/recognize" element={
            <RouteGuard allow={['admin', 'manager']}><Recognize /></RouteGuard>
          } />
          <Route path="/issue-warning" element={
            <RouteGuard allow={['admin', 'manager']}><IssueWarning /></RouteGuard>
          } />

          <Route path="/leave" element={
            <RouteGuard allow={['admin', 'manager']}><LeaveApprovals /></RouteGuard>
          } />
          <Route path="/leave/request" element={
            <RouteGuard><LeaveRequest /></RouteGuard>
          } />
          <Route path="/evaluations" element={
            <RouteGuard allow={['admin', 'manager']}><EvaluationCycle /></RouteGuard>
          } />
          <Route path="/evaluations/:empId" element={
            <RouteGuard allow={['admin', 'manager']}><EvaluationForm /></RouteGuard>
          } />
          {/* เงิน/ค่าชดเชย = แอดมินเท่านั้น (หัวหน้าไม่มีสิทธิ์) */}
          <Route path="/recommendations" element={
            <RouteGuard allow={['admin']}><Recommendations /></RouteGuard>
          } />
          <Route path="/severance" element={
            <RouteGuard allow={['admin']}><Severance /></RouteGuard>
          } />

          {/* any authenticated user (RLS scopes visibility) */}
          <Route path="/attendance/:id" element={
            <RouteGuard><AttendanceMonth /></RouteGuard>
          } />
          <Route path="/warnings/:id" element={
            <RouteGuard><WarningDetail /></RouteGuard>
          } />
          <Route path="/warnings/:id/print" element={
            <RouteGuard><WarningLetter /></RouteGuard>
          } />
          <Route path="/me" element={
            <RouteGuard><Me /></RouteGuard>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
